module.exports = __webpack_public_path__ + "img/300px-Sha_Tin_Station_Platform_2011.8c1cb17c.jpg";